import React, { useEffect } from "react";
import DataTable from "react-data-table-component";
import { Button } from "react-bootstrap";

import columns from "./Table/columns";

import { usePolicyPlanCustomRecordTemplateContext } from "../../../contexts/PolicyPlanCustomRecordTemplateContext";

export default function Table() {
  const { dispatch, actions, state } =
    usePolicyPlanCustomRecordTemplateContext();

  useEffect(() => {
    actions.load(dispatch);
  }, []);

  return (
    <>
      <div className="text-right">
        <Button
          onClick={() => actions.showCreateForm(dispatch)}
          bsStyle="primary"
        >
          Add Service
        </Button>
      </div>
      <div className="datatable-style">
        <DataTable
          title=""
          columns={columns}
          data={state.templates || []}
          noDataComponent={
            <div className="mt20">
              {state.templates == null
                ? "Please, wait ..."
                : "No matching records found"}
            </div>
          }
          persistTableHead={true}
          pagination
          paginationComponentOptions={{
            selectAllRowsItem: true,
            selectAllRowsItemText: "All",
          }}
        />
      </div>
    </>
  );
}
